import { defineStore } from "pinia";

import { ACTION_TRANSITIONS_SET, GETTER_TRANSITIONS_GET, ACTION_TRANSITIONS_RESET } from "@core/store/types";

export const useCssTransitionsStore = defineStore("cssTransitions", {
  state: () => ({
    transition: "RIGHT",
  }),
  getters: {
    [GETTER_TRANSITIONS_GET]: (state) => state.transition,
  },
  actions: {
    [ACTION_TRANSITIONS_SET](transition) {
      this.transition = transition;
    },
    [ACTION_TRANSITIONS_RESET]() {
      this.clearCssTransitionsStore();
    },
    // easily reset state using `$reset`
    clearCssTransitionsStore() {
      this.$reset();
    },
  },
});
